var exports = {
  "Q": "xdde3148b--58af53--content",
};

module.exports = exports;
